import { useContext } from 'react';
import ReactRoutesContext from 'components/providers/ReactRoutes/ReactRoutesContext';

export const useReactRoutes = () => {
  const context = useContext(ReactRoutesContext);

  if (!context) {
    return {
      isReactAppMounted: false,
    };
  }

  return context;
};

export default useReactRoutes;
